var $7dfe84ba28f38545$exports = {};
$7dfe84ba28f38545$exports = {
    "colorSwatchPicker": `Amostras de cores`,
    "dropzoneLabel": `DropZone`,
    "selectPlaceholder": `Selecione um item`,
    "tableResizer": `Redimensionador`
};


export {$7dfe84ba28f38545$exports as default};
//# sourceMappingURL=pt-BR.mjs.map
